export default __webpack_public_path__ + "static/media/home-creative-portfolio-img-01.85d10048.jpg";